import React from 'react';
import {
  Card,
  CardProps,
  CardActionArea,
  Grid,
  Avatar,
  SxProps,
} from '@mui/material';

import { IQuestionDetailAnswer } from '../../../../store/QuestionSlice';
import { TP_COLORS } from '../../../../constants';

const avatarOrangeStyles: SxProps = {
  color: TP_COLORS.orange.light,
  backgroundColor: TP_COLORS.orange.lighter,
  borderColor: TP_COLORS.orange.light,
};

const avatarGreenStyles: SxProps = {
  color: TP_COLORS.green.light,
  backgroundColor: TP_COLORS.green.lighter,
  borderColor: TP_COLORS.green.light,
};

const markingDivStyles: React.CSSProperties = {
  maxHeight: '400px',
  overflowY: 'auto',
  display: 'flex',
};

export interface IAnswerListItem {
  answer: IQuestionDetailAnswer;
  onClick?: (answerId: string) => void;
  showAnswer?: boolean;
  markingSchema?: string;
  selectedAnswerId?: string;
}

const AnswerListItem: React.FC<IAnswerListItem> = ({
  answer,
  onClick = undefined,
  showAnswer = false,
  markingSchema,
  selectedAnswerId,
}) => {
  const _order = (answer.order + 1).toString().padStart(2, '0');

  const answerCardStyles: CardProps['style'] = {
    border: '1px solid #E2E8F0',
    borderRadius: '30px',
  };

  let avatarStyles: SxProps = {
    fontSize: '16px',
    fontWeight: 600,
    margin: '10px',
    color: TP_COLORS.gray.dark,
    backgroundColor: TP_COLORS.listItemGray.light,
    border: `1px solid ${TP_COLORS.border.color2}`,
  };

  if (selectedAnswerId === answer._id) {
    answerCardStyles.backgroundColor = TP_COLORS.tutopiyaGreenMain.darken;
  }

  if (showAnswer) {
    answerCardStyles.backgroundColor = undefined;
    if (answer.isCorrect && selectedAnswerId === answer._id) {
      answerCardStyles.borderColor = '#56C955'; // GREEN
      avatarStyles = {
        ...avatarStyles,
        ...avatarGreenStyles,
      };
    } else if (!answer.isCorrect && selectedAnswerId === answer._id) {
      answerCardStyles.borderColor = TP_COLORS.orange.light; // Orange
      avatarStyles = {
        ...avatarStyles,
        ...avatarOrangeStyles,
      };
    } else if (answer.isCorrect) {
      answerCardStyles.borderColor = '#56C955'; // GREEN
      avatarStyles = {
        ...avatarStyles,
        ...avatarGreenStyles,
      };
    }
  }

  return (
    <Card style={{ boxShadow: 'unset' }}>
      <CardActionArea
        sx={answerCardStyles}
        disabled={onClick === undefined}
        onClick={() => {
          if (onClick && answer._id) {
            onClick(answer._id);
          }
        }}
      >
        <Grid container alignItems="center">
          <Grid item xs={2} sm={2} style={{ maxWidth: '50px' }}>
            <Avatar sx={avatarStyles}>{_order}</Avatar>
          </Grid>
          <Grid item xs={10}>
            <div
              style={{ color: answerCardStyles.borderColor }}
              className="view ql-editor ql-viewer"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: answer.content }}
            />
          </Grid>
          {showAnswer && answer.isCorrect && markingSchema && (
            <Grid item>
              <div style={markingDivStyles}>
                <div
                  className="view ql-editor ql-viewer"
                  style={{
                    paddingTop: '0',
                    paddingLeft: '65px',
                  }}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: markingSchema,
                  }}
                />
              </div>
            </Grid>
          )}
        </Grid>
      </CardActionArea>
    </Card>
  );
};

export default AnswerListItem;
